import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import getChartColorsArray from '../../../../../Components/Common/ChartsDynamicColor';
import biomass_7d from './DataDummy/biomass_7d.json';
import biomass_15d from './DataDummy/biomass_15d.json';
import biomass_30d from './DataDummy/biomass_30d.json';
import data_biomass_cage from './DataDummy/biomass_cage.json'

import moment from 'moment';

const RelativeGrowthIndex = ({ title, dataColors }) => {
    const [seriesMonth, setSeriesMonth] = useState([]);
    const [seriesCage, setSeriesCage] = useState([]);
    const [monthsFound, setMonthsFound] = useState([]);
    const [cagesFound, setCagesFound] = useState([]);

    const [maxMinValues, setMaxMinValues] = useState({
        maxUnits: 0,
        minUnits: 0,
        maxBiomass: 0,
        minBiomass: 0,
        maxAvgWeight: 0,
        minAvgWeight: 0,
    });

    // Estado para controlar la vista: Jaula o Mes
    const [selectedView, setSelectedView] = useState('cage');

    // Estado para controlar el rango temporal
    const [selectedTimeRange, setSelectedTimeRange] = useState('7d');

    // Mapear rangos temporales a los datos correspondientes
    const dataSources = {
        // '7d': biomass_7d,
        // '15d': biomass_15d,
        // '30d': biomass_30d,
    };

    useEffect(() => {
        // Obtener los datos según el rango temporal seleccionado
        const selectedData = dataSources[selectedTimeRange] || [];

        // Ordenar datos por "Closing Date"
        const sortedData = [...selectedData].sort((a, b) => {
            const dateA = moment(a["Closing Date"], "DD/MM/YYYY HH:mm:ss");
            const dateB = moment(b["Closing Date"], "DD/MM/YYYY HH:mm:ss");
            return dateA - dateB;
        });

        // Procesar datos para las series
        const units = sortedData.map((item) => Math.round(item["Closing Count"]));
        const biomass = sortedData.map((item) => Math.round(item["Closing Biomass"] / 1000));
        const avgWeight = sortedData.map((item) => (item["Closing Avg weight"] / 1000).toFixed(2));

        const series = [
            { name: "Unidades", type: "column", data: units },
            { name: "Biomasa", type: "column", data: biomass },
            { name: "Peso Promedio", type: "line", data: avgWeight },
        ];

        // Calcular máximos y mínimos
        const maxUnits = Math.max(...units);
        const minUnits = Math.min(...units);
        
        const maxBiomass = Math.max(...biomass);
        const minBiomass = Math.min(...biomass);
        
        const maxAvgWeight = parseFloat(Math.max(...avgWeight).toFixed(2)); // Convertir a número con 2 decimales
        const minAvgWeight = parseFloat(Math.min(...avgWeight).toFixed(2)); // Convertir a número con 2 decimales
        


        setMaxMinValues({
            maxUnits,
            minUnits,
            maxBiomass,
            minBiomass,
            maxAvgWeight,
            minAvgWeight,
        });


        const series_cage = [
            {
                name: "Biomasa",
                type: "column",
                data: sortedData.map((item) => Math.round(item["Closing Biomass"] / 1000)),
            },
            {
                name: "Biomasa Proyectada",
                type: "column",
                data: sortedData.map((item) =>
                    Math.round((item["Closing Biomass"] * 1.025) / 1000)
                ),
            },
            {
                name: "Peso Promedio - kg",
                type: "line",
                data: sortedData.map((item) => item["Closing Avg weight"]),
            },
        ];

        // Obtener las fechas para el eje X
        const months = sortedData.map((item) => item["Formatted Date"]); // Usar sortedData para fechas ordenadas
        const cages = data_biomass_cage.map((item) => item.generalUnit);

        // Actualizar los estados
        setSeriesMonth(series);
        setSeriesCage(series_cage);
        setMonthsFound(months);
        setCagesFound(cages);


    }, [selectedTimeRange]);


    const chartMultiColors = getChartColorsArray(dataColors);

    const options = {
        chart: {
            stacked: false,
            toolbar: false,
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            width: [1, 1, 1],
        },
        xaxis: {
            categories: selectedView === 'cage'
                ? cagesFound
                : monthsFound,
            labels: {
                style: {
                    fontSize: '8px', // Tamaño del texto del eje X ajustado a 8px
                },
            },
        },
        yaxis: [
            {
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: "#038edc",
                },
                labels: {
                    style: {
                        colors: "#038edc",
                        fontSize: '8px',
                        rotate: -70,
                    },
                    formatter: function (value) {
                        if (value == null) return ""; // Maneja valores undefined o null
                        const roundedValue = Math.round(value); // Redondea al entero más cercano
                        return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Formatea con separadores de miles
                    },
                },
                min: maxMinValues.minUnits,
                max: maxMinValues.maxUnits,
                title: {
                    text: "Unidades",
                    style: {
                        color: "#038edc",
                        fontWeight: 600,
                    },
                },
                tooltip: {
                    enabled: true,
                },
            },
            {
                opposite: true,
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: "#038edc",
                },
                labels: {
                    style: {
                        colors: "#038edc",
                        fontSize: '8px',
                        rotate: -70,
                    },
                    formatter: function (value) {
                        if (value == null) return ""; // Maneja valores undefined o null
                        const roundedValue = Math.round(value); // Redondea al entero más cercano
                        return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Formatea con separadores de miles
                    },
                },
                min: maxMinValues.minBiomass,
                max: maxMinValues.maxBiomass,
                title: {
                    text: "Biomasa - ton",
                    style: {
                        color: "#038edc",
                        fontWeight: 600,
                    },
                },
            },
            {
                opposite: true,
                axisTicks: {
                    show: true,
                },
                axisBorder: {
                    show: true,
                    color: "#51d28c",
                },
                labels: {
                    style: {
                        colors: "#51d28c",
                        fontSize: '8px',
                        rotate: -70,
                    },
                    formatter: function (value) {
                        if (value == null) return ""; // Maneja valores undefined o null
                        return parseFloat(value) // Asegura que sea un número
                            .toFixed(2) // Limita a 2 decimales
                            .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Aplica separadores de miles
                    }
                    
                },
                min: maxMinValues.minAvgWeight,
                max: maxMinValues.maxAvgWeight,
                title: {
                    text: "Peso Promedio - kg",
                    style: {
                        color: "#51d28c",
                        fontWeight: 600,
                    },
                },
            },
        ],
        tooltip: {
            fixed: {
                enabled: true,
            },
        },
        legend: {
            horizontalAlign: "center",
            offsetX: 40,
        },
        colors: chartMultiColors,
    };

    const getSelectedSeries = () => {
        return selectedView === 'cage' ? seriesCage : seriesMonth;
    };

    return (
        <Card style={{ height: "100%" }}>
            <CardHeader className='p-2 align-items-center d-flex'>
                <h5 className="card-title mb-0 flex-grow-1">Crecimiento</h5>
                <div className='btn-box-dashboard'>
                    {/* Primera parte: Cage/Time */}
                    <Button
                        color="secondary"
                        size="sm"
                        className="btn-soft-secondary me-1"
                        onClick={() => setSelectedView('cage')}
                        active={selectedView === 'cage'}
                    >
                        Jaula
                    </Button>
                    <Button
                        color="primary"
                        size="sm"
                        className="btn-soft-primary me-1"
                        onClick={() => setSelectedView('month')}
                        active={selectedView === 'month'}
                    >
                        Tiempo
                    </Button>
                    |
                    {/* Segunda parte: Rango temporal */}
                    {['7d', '15d', '30d'].map((range) => (
                        <Button
                            key={range}
                            color="secondary"
                            size="sm"
                            className="btn-soft-secondary me-1"
                            onClick={() => setSelectedTimeRange(range)}
                            active={selectedTimeRange === range}
                        >
                            {range}
                        </Button>
                    ))}
                </div>
            </CardHeader>
            <CardBody className='p-2'>
                <div className="w-100">
                    <div dir="ltr">
                        <ReactApexChart
                            dir="ltr"
                            className="apex-charts"
                            options={{
                                ...options,
                                noData: {
                                    text: "No hay datos disponibles. Pronta conexión con el sistema de alimentación",
                                    align: "center",
                                    verticalAlign: "middle",
                                    style: {
                                        color: "#999",
                                        fontSize: "11px",
                                    },
                                },
                            }}
                            series={getSelectedSeries()}
                            type="line"
                            height={200}
                        />
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default RelativeGrowthIndex;
